<!--  -->
<template>
    <div class="business-content-main" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(1)" v-if="permission.add">{{ permission.add }} (F3)</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                border
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                :tableCode="tableCode"
                v-loading="loading"
                row-key="getRowKey"
                @sort-change="sortChange"
            >
                <template v-for="(col,index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                </template>
                <el-table-column label="操作" fixed="right" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit" title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{ permission.edit }}</el-button>
                            <el-button v-if="permission.del" title="删除" size="mini" type="text" style="color: red" @click="del(scope.row)">{{ permission.del }}</el-button>                         
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="客户信息" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="EntpCusId" :type="dialogType" @closeDialog="closeDialog" source="1" fromPage="1"></customerEdit>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="客户搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-cus-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_cus"
                            size="small"
                            v-model="searchData.Name"
                            remote
                            filterable
                            clearable
                            allow-create
                            placeholder="客户名称"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                            style="width: 100%"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话号码" v-if="isExObj('CallNum')">
                        <el-input size="small" v-model.trim="searchData.CallNum" v-filter-special-char="searchData.CallNum" placeholder="电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="地区" v-if="isExObj('Zone')">
                        <el-input size="small" v-model.trim="searchData.Zone" v-filter-special-char="searchData.Zone" placeholder="地区"></el-input>
                    </el-form-item>
                    <el-form-item label="客户来源" v-if="isExObj('Source')">
                        <el-select style="width: 100%" size="small" filterable clearable v-model="searchData.Source" @visible-change="sourceVisibleChange($event)">
                            <el-option v-for="optionItem in sourceList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跟进人" v-if="isExObj('Follower')">
                        <el-select
                            v-model="searchData.FollowerId"
                            style="width: 100%"
                            @visible-change="staffVisibleChange($event)"
                            filterable
                            placeholder="请选择"
                            size="small"
                            clearable
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import customerEdit from '@/components/business/ecPlatform/customerEdit_ec';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        customerEdit,
        breadcrumb,
        elTableColumn,
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            datetime1: [],
            datetime2: [],
            tableCode: 'EC-CusTable',
            EntpCusId: '',
            EntpCusName: '',
            sourceList: [],
            dialogType: '-1',
            dialogVisible: false,
            dialogInvoiceVisible: false,
            dialogSearchVisible: false,
            searchData: {
                Name: '',
                MainVehicle: '',
                MainPartName: '',
                Zone: '',
                CallNum: '',
                Tags: '',
                Source: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                Symbol: '',
                PayType: '',
                SortProp: '',
                SortType: '',
                CreditMoney1: 0,
                CreditMoney2: 0,
                page: 1,
                limit: 15
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0,
            permission: {},
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isStartSearch: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_cus.focus();
                });
            }
        },
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.permission = this.$util.getPermission('ecCusManage');
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 113) {
                e.preventDefault();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(1);
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        closeDialog(edit) {
            this.EntpCusId = '';
            this.dialogVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        add(type, item) {
            this.EntpCusId = '';
            this.dialogType = type;
            if (type == 2 || type == 3) {
                this.EntpCusId = item.EntpCusId;
            }
            this.dialogVisible = true;
        },
        // 删除客户
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该客户吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpCustomers/DelEntpCustomer',
                            data: {
                                EntpCusId: row.EntpCusId
                            }
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        resetSearch() {
            this.searchData = {
                Name: '',
                MainVehicle: '',
                MainPartName: '',
                Zone: '',
                CallNum: '',
                Tags: '',
                Source: '',
                FollowerId: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                Symbol: '',
                PayType: '',
                SortProp: '',
                SortType: '',
                CreditMoney1: 0,
                CreditMoney2: 0,
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime1 = [];
            this.datetime2 = [];
            // this.searchCustom('');
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetEntpCusList_EC',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        getSourceList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEnterpriseCustomerSources',
                    hideLoading: true
                })
                .then(res => {
                    this.sourceList = res.data;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.add(3, event);
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sourceList.length == 0) that.getSourceList();
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        staffVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length == 0) that.getSIdList();
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        getRowKey(row) {
            return row.EntpCusId;
        }
    }
};
</script>
<style lang="less" scoped>
#search-cus-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
#apply-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 65vh;
    left: 60vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
.e-item1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
}
.e-item2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
}
</style>
